import React from 'react';
import { useRouter } from '@uirouter/react';
import { UserPermissionsSidebarInternalComponent } from '@react/Pages/UsersPage/UserPermissionSidebar/UserPermissionsSidebar';
import { connectWithStore } from '@react/Common/connectWithStore';
import { createUser, resetState } from '@redux/ducks/userPermissions/userPermissions';

interface CreateUserSidebarOwnProps {
  routerProps: {
    backPath: string;
  };
}

interface CreateUserSidebarDispatchProps {
  onSubmit: (email?: string) => void;
  onClose: () => void;
}

type CreateUserSidebarProps = CreateUserSidebarDispatchProps & CreateUserSidebarOwnProps;

const CreateUserSidebarComponent: React.FC<CreateUserSidebarProps> = ({ routerProps, onSubmit, onClose }) => {
  const router = useRouter();

  const closeHandler = () => {
    onClose();
    router.stateService.go(routerProps.backPath);
  };

  return <UserPermissionsSidebarInternalComponent onClose={closeHandler} onSubmit={onSubmit} />;
};

const mapStateToDispatch = {
  onSubmit: createUser,
  onClose: resetState,
};

export const CreateUserSidebar = connectWithStore(null, mapStateToDispatch)(CreateUserSidebarComponent);
